
//dynamic image
const images = require.context(`/public/assets/images`, true);

export const dynamicImage = (image: string | undefined) => {
    return images(`./${image}`);
};

//dynamic Number
export function dynamicNumber(totalLength: number) {
    return Array.from({ length: totalLength }, (_, index) => index + 1);
};

export const formatDate = (date: string) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const year = newDate.getFullYear();
    return `${day}-${month}-${year}`;
}

export const numberFormat = (number: string | number, minDecimal: number = 2, maxDecimal: number = 2) => {
    return new Intl.NumberFormat(undefined, { minimumFractionDigits: minDecimal, maximumFractionDigits: 2 }).format(Number(number));
}

/**
 * Sorts an array of objects by a given key.
 * @param array The array to sort.
 * @param key The key of the object to sort by.
 * @returns The sorted array (in-place).
 */
export const sortByKey = <T, K extends keyof T>(array: T[], key: K): T[] => {
    return array.sort((a, b) => {
        const aValue = a[key];
        const bValue = b[key];

        if (typeof aValue === 'string' && typeof bValue === 'string') {
            return aValue.localeCompare(bValue);
        }
        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
    });
};